<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_IS_VIEW_ALL_EXPERTISE, SET_MAIN_MENU } from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";

export default {
  name: "ProjectMenu",
  watch: {
    isLoading(val) {
      if (!val) {
        this.makeMenu();
      }
    }
  },
  computed: {
    ...mapGetters(["project", "isLoading", "directory", "currentUser"])
  },
  methods: {
    getStatus: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    },
    async makeMenu() {
      let navMainMenu = [];

      if (this.currentUser.TYPE_USER === "declarer") {
        navMainMenu = [
          {
            name: "Мои проекты",
            route: "Projects"
          },
          {
            name: "Резюме проекта",
            route: "ProjectEdit",
            params: { id: this.project.ID }
          }
        ];

        navMainMenu.push({
          name: "Подача заявки",
          route: "ScenarioRequest",
          params: { id: this.project.ID }
        });

        /*const { data } = await ProjectsService.getRulesChangeStatusUser(
          this.project.UF_STATUS_ID
        );

        if (data.IS_VIEW_DOGOVOR_ZAIMA && this.project.UF_IS_VIEW_DZ_USER) {
          navMainMenu.push({
            name: "Оформление ДЗ",
            route: "AddDZ",
            params: { id: this.project.ID }
          });
        }*/

        navMainMenu.push({
          name: "Уведомления",
          route: "ProjectNotifications",
          params: { id: this.project.ID }
        });

        await this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      } else {
        const managerSettings = await ProjectsService.getManagerRoleDefaultSetting();
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          managerSettings.data.IS_VIEW_ALL_EXPERTISE
        );

        if (managerSettings.data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (managerSettings.data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        if (
          managerSettings.data.IS_VIEW_PLAN_ES &&
          this.currentUser.ACTIVE_ROLE == 38
        ) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (this.currentUser.ACTIVE_ROLE == 37) {
          navMainMenu.push({
            name: "Заседания",
            route: "Conference"
          });
        }
        if (
          managerSettings.data.IS_VIEW_SUBMITTED_PROJECTS &&
          this.currentUser.ACTIVE_ROLE == 37
        ) {
          navMainMenu.push({
            name: "Вынесенные проекты",
            route: "SubmittedProjects"
          });
        }

        navMainMenu.push({
          name: "Резюме проекта",
          route: "ProjectEdit",
          params: { id: this.project.ID }
        });

        if (
          this.currentUser.ACTIVE_ROLE != 37 &&
          this.currentUser.ACTIVE_ROLE != 40
        ) {
          navMainMenu.push({
            name: "Подача заявки",
            route: "ScenarioRequest",
            params: { id: this.project.ID }
          });
        }

        const {
          data: statusData
        } = await ProjectsService.getRulesChangeStatusUser(
          this.project.UF_STATUS_ID
        );

        if (
          this.currentUser.ACTIVE_ROLE != 34 &&
          this.currentUser.ACTIVE_ROLE != 37 &&
          this.project.UF_STATUS_ID &&
          this.project.UF_STATUS_ID > 0
        ) {
          if (this.getStatus(this.project.UF_STATUS_ID).IS_DOCUMENTS_VIEW) {
            navMainMenu.push({
              name: "Документы проекта",
              route: "ProjectDocuments",
              params: { id: this.project.ID }
            });
          }
        }

        if (statusData.IS_CMP_IND_VIEW) {
          navMainMenu.push({
            name: "Показатели компании",
            route: "Indicators",
            params: { id: this.project.ID }
          });
        }

        if (statusData.IS_EDIT_IR === 1 || statusData.IS_VIEW_IR === 1) {
          navMainMenu.push({
            name: "Участие ИР в проекте",
            route: "ProjectInstitutes",
            params: { id: this.project.ID }
          });
        }

        if (this.currentUser.ACTIVE_ROLE_CODE === "manager3") {
          navMainMenu.push({
            name: "Встречи",
            route: "ProjectMeeting",
            params: { id: this.project.ID }
          });
        }

        if (statusData.IS_VIEW_PANEL_EXPERTISE) {
          navMainMenu.push({
            name: "Статус экспертиз проекта",
            route: "ExpertStatus",
            params: { id: this.project.ID }
          });
        }

        if (
          ["manager3", "manager2", "OMP_staff", "admin", "director"].includes(
            this.currentUser.ACTIVE_ROLE_CODE
          )
        ) {
          navMainMenu.push({
            name: "Доп. информация",
            route: "AddInfo",
            params: { id: this.project.ID }
          });
        }

        if (managerSettings.data.IS_VIEW_NOTIFICATIONS) {
          navMainMenu.push({
            name: "Уведомления",
            route: "ProjectNotifications",
            params: { id: this.project.ID }
          });
        }

        if (statusData.IS_VIEW_DOGOVOR_ZAIMA) {
          navMainMenu.push({
            name: "Оформление ДЗ",
            route: "AddDZ",
            params: { id: this.project.ID }
          });
        }

        if (
          this.currentUser.ACTIVE_ROLE != 37 &&
          this.currentUser.ACTIVE_ROLE != 40
        ) {
          navMainMenu.push({
            name: "Запросы",
            query: {filter: JSON.stringify({
                project_number: this.project.UF_NUMBER,
                number: '',
                status: [],
                initiator: [],
                organization: [],
                performer: ""
            })},
            route: "Requests"
          });
        }
        await this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      }
    }
  }
};
</script>

<style scoped></style>
